export default __webpack_public_path__ + "static/media/ico_reports.2fe1ca22.svg";